import React, { useState } from "react";
import "./AboutUsSection3.css";
import AboutUsDivider from "../AboutUsDivider/AboutUsDivider";
import { useTranslation } from "react-i18next";

const AboutUsSection3 = () => {
  const [activeIndex, setActiveIndex] = useState(null);
  const { t } = useTranslation("global");

  const toggleAccordion = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const accordionItems = [
    {
      id: 1,
      title: t("aboutUsSection3.accordion.growth.title"),
      content: t("aboutUsSection3.accordion.growth.content"),
    },
    {
      id: 2,
      title: t("aboutUsSection3.accordion.adaptability.title"),
      content: t("aboutUsSection3.accordion.adaptability.content"),
    },
    {
      id: 3,
      title: t("aboutUsSection3.accordion.trust.title"),
      content: t("aboutUsSection3.accordion.trust.content"),
    },
    {
      id: 4,
      title: t("aboutUsSection3.accordion.longTermPartnerships.title"),
      content: t("aboutUsSection3.accordion.longTermPartnerships.content"),
    },
    {
      id: 5,
      title: t("aboutUsSection3.accordion.collaboration.title"),
      content: t("aboutUsSection3.accordion.collaboration.content"),
    },
  ];

  return (
    <section>
      <AboutUsDivider heading={t("aboutUsSection3.divider.heading")} />
      <section className="vision-section">
        <header className="vision-header">
          <h2>{t("aboutUsSection3.visionHeader.heading")}</h2>
          <p>{t("aboutUsSection3.visionHeader.description")}</p>
        </header>
        <section className="accordion">
          {accordionItems.map((item, index) => (
            <article className="accordion-item" key={item.id}>
              <button
                className="accordion-button"
                onClick={() => toggleAccordion(index)}
                aria-expanded={activeIndex === index ? "true" : "false"}
              >
                <span className="accordion-title">{item.title}</span>
                <span className="accordion-icon">
                  {activeIndex === index ? "-" : "+"}
                </span>
              </button>
              {activeIndex === index && (
                <div className="accordion-content">
                  <p>{item.content}</p>
                </div>
              )}
            </article>
          ))}
        </section>
      </section>
    </section>
  );
};

export default AboutUsSection3;
